import { Component, OnInit, Input, Output, ElementRef, EventEmitter, HostBinding } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { IconModel } from '../../models/icon/icon.model';
import { IconStylingModel } from '../../models/icon/icon-styling.model';
import { IconTemplates } from '../../templates/icon.template';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CF Icon Component</p>
 * <pre>
 * <code>
 * import {{'{'}} IconModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} IconStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-icon<code>></code><code><</code><code>/</code>cf-icon<code>></code>
 * </code>
 * </pre>
 */
export class CfIconComponent extends CfCoreComponent implements OnInit {
/**
 * @hidden
 */
notificationClickable = '';
/**
 * @hidden 
 * <p>Whether the icon is in toggle mode or normal mode.</p>
 */
checked = true;
/**
 * @hidden
 */
currentIcon: any = {};
/**
 * <pre>{{'{'}}
 *  display: boolean,  // Default: true.
 *  disable: boolean,  // Default: false.
 *  name: string,      // Default: cloud.
 *  size: string,      // Default: 24px.
 *  value: any,        // Value emitted on click
 *  toggle:{{'{'}}      // Toggling icon state
 *   name: string,     // Name of icon toggled
 *   size: string,     // Size of icon toggled
 *   value: any        // Value of icon toggled
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  name: 'fa-heart-o',
 *  size: '18px',
 *  value: 'empty heart',
 *  toggle: {{'{'}}
 *    name: 'fa-heart',
 *    size: '18px',
 *    value: 'full heart'
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 */
public properties: IconModel;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the Icon
 *  container:{{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // md-icon styling
 *  icon:{{'{'}}
 *    dynamicClass,
 *    class,
 *    themeColor
 *  {{'}'}},
 *  // Toggle Icon styling with same structure as above
 *  toggleIcon:{{'{'}}
 *    container: {{'{'}}{{'}'}},
 *    icon: {{'{'}}{{'}'}}
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 */
public styling: IconStylingModel;
/**
 * <p></p>
 * <p>Name of the icon</p>
 * <p>Default is <b>home</b></p>
 * <p>Icon libraries available: Material Icons and Font Awesome Icons</p>
 * @param {?} value
 * @return {?}
 */
set name(value: string) {
    this.properties.name = value;
    this.properties.type = this.properties.name.startsWith('fa-') ? 'fa' : 'mi';
  }
/**
 * <p>Icon size</p>
 * <p>Can be in pixels, em, percetages </p>
 * <p>Default is <b>'24px'</b></p>
 * @param {?} value
 * @return {?}
 */
set size(value: string) { this.properties.size = value; }
/**
 * <b>Output</b>
 * <p>Event emited on toggle</p>
 */
cfOnToggle: EventEmitter<any> = new EventEmitter<any>();
/**
 * @hidden 
 * It is function for set correct toggle value/icon and emmit event with icon state value.
 * @return {?}
 */
cfIconToggled() {
    if (this.properties.toggle != null) {
      this.checked = !this.checked;
      let /** @type {?} */ temp = {
        name: this.properties.name,
        value: this.properties.value,
        size: this.properties.size
      };
      this.properties.name = this.properties.toggle.name;
      this.properties.value = this.properties.toggle.value;
      this.properties.size = this.properties.toggle.size;
      this.properties.toggle.name = temp.name;
      this.properties.toggle.value = temp.value;
      this.properties.toggle.size = temp.size;
    }
  }
/**
 * @hidden 
 * It is function for creating Notification click events by using Core Component <b>notificationAction</b> event emmiter.
 * @param {?} notification  it is json notification object
 * @return {?}
 */
cfNotificationAction(notification) { this.notificationAction.emit(notification); }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(
public elementRef: ElementRef,
public templateService: TemplateService) {
    super(elementRef, templateService);
    this.properties = new IconModel();
    this.styling = new IconStylingModel();
  }
/**
 * @hidden 
 * <p>On Icon component initialization next things are heppening:</p>
 * <ul>
 * <li>Inititlaizing the properties and styling objects if not initialized and pass the external inputs to over write if any</li>
 * <li>Binding the html template object to the passed properties object</li>
 * </ul>
 * 
 * @return {?}
 */
ngOnInit() {
    if (this.notificationAction.observers.length > 0) { this.notificationClickable = 'notification-clickable'; }
    this.getMyTemplate('icon', IconTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'ICON').then( sampler => {
        this.properties.type = this.properties.name.startsWith('fa-') ? 'fa' : 'mi';
        this.currentIcon = this.properties;
        // console.log('ICON', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-icon',
  template: "<div *ngIf=\"_inited && currentIcon?.display\" class=\"{{activeTemplate.style?.container?.class}} {{checked ? styling?.container?.class : styling?.toggleIcon?.container? styling?.toggleIcon?.container?.class: styling?.container?.class}} {{getDynamicClasses(activeTemplate.style?.container?.dynamicClass)}} {{getDynamicClasses(styling?.container?.dynamicClass)}}\" [ngClass]=\"'cf-icon-container'\" [ngStyle]=\"{'width': checked ? currentIcon.size: currentIcon.toggle.size, 'height': checked ? currentIcon.size: currentIcon.toggle.size}\"> <md-icon (click)=\"cfIconToggled()\" class=\"mat-icon cf-icon-style cf-toggling-icon {{activeTemplate.style?.icon?.class}} {{checked ? styling?.icon?.class : styling?.toggleIcon?.icon? styling?.toggleIcon?.icon?.class: ''}} {{currentIcon?.disable ? 'disable' : ''}} {{getDynamicClasses(activeTemplate.style?.icon?.dynamicClass)}} {{getDynamicClasses(styling?.icon?.dynamicClass)}}\" md-tooltip=\"{{ tooltip ? tooltip.message : tooltip }}\" tooltip-position=\"{{ tooltip ? tooltip.position : '' }}\" [ngClass]=\"'cf-icon'\" fontSet=\"{{ currentIcon.type === 'fa' ? 'fa': 'material-icons' }}\" fontIcon=\"{{ currentIcon.type === 'fa' ? currentIcon.name : '' }}\" [color]=\"styling?.icon?.themeColor || activeTemplate.style?.icon?.themeColor\" [ngStyle]=\"{'fontSize': checked? currentIcon?.size : currentIcon?.toggle?.size, 'width': checked ? currentIcon?.size: currentIcon?.toggle?.size, 'height': checked ? currentIcon?.size : currentIcon?.toggle?.size}\">{{currentIcon?.type === 'mi' ? currentIcon?.name : ''}}</md-icon> <cf-notification *ngIf=\"notification && (notification.value || notification?.icon)\" [settings]=\"notification\" (click)=\"cfNotificationAction(notification)\"></cf-notification> </div> ",
  styles: [":host { position: relative; z-index: 0; display: inline-flex; } :host > div { line-height: 0; } :host md-icon.disable { color: rgba(0, 0, 0, 0.38) !important; background: transparent !important; background-color: transparent !important; cursor: default !important; } :host.cf-menu-trigger md-icon { cursor: pointer; transition: all 0.2s ease; } :host.cf-menu-trigger md-icon:hover { transform: scale(1.1); } :host .cf-toggling-icon { cursor: pointer; } :host.notification-clickable cf-notification:hover { cursor: pointer; } :ng-deep md-icon.cf-icon.mat-icon { padding: 0px; } .cf-close-icon { color: #EF5350; } @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) { :ng-deep md-icon.material-icons { line-height: 1.2; font-feature-settings: 'liga'; } } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notificationClickable': [{ type: HostBinding, args: ['class', ] },],
'properties': [{ type: Input },],
'styling': [{ type: Input },],
'name': [{ type: Input, args: ['name', ] },],
'size': [{ type: Input, args: ['size', ] },],
'cfOnToggle': [{ type: Output },],
};
}

function CfIconComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfIconComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfIconComponent.ctorParameters;
/** @type {?} */
CfIconComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfIconComponent.prototype.notificationClickable;
/**
 * @hidden 
 * <p>Whether the icon is in toggle mode or normal mode.</p>
 * @type {?}
 */
CfIconComponent.prototype.checked;
/**
 * @hidden
 * @type {?}
 */
CfIconComponent.prototype.currentIcon;
/**
 * <pre>{{'{'}}
 *  display: boolean,  // Default: true.
 *  disable: boolean,  // Default: false.
 *  name: string,      // Default: cloud.
 *  size: string,      // Default: 24px.
 *  value: any,        // Value emitted on click
 *  toggle:{{'{'}}      // Toggling icon state
 *   name: string,     // Name of icon toggled
 *   size: string,     // Size of icon toggled
 *   value: any        // Value of icon toggled
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * <p>Example</p>
 * <pre>{{'{'}}
 *  name: 'fa-heart-o',
 *  size: '18px',
 *  value: 'empty heart',
 *  toggle: {{'{'}}
 *    name: 'fa-heart',
 *    size: '18px',
 *    value: 'full heart'
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfIconComponent.prototype.properties;
/**
 * <p> dynamicClass: function() -> string,  // Function that returns name of the class </p>
 * <p> class: string                        // Name of the css class selector </p>
 * <p> themeColor: string                   // primary/accent/warn </p>
 * <pre>
 * {{'{'}}
 *  // Container surrounding the Icon
 *  container:{{'{'}}
 *    dynamicClass,
 *    class
 *  {{'}'}},
 *  // md-icon styling
 *  icon:{{'{'}}
 *    dynamicClass,
 *    class,
 *    themeColor
 *  {{'}'}},
 *  // Toggle Icon styling with same structure as above
 *  toggleIcon:{{'{'}}
 *    container: {{'{'}}{{'}'}},
 *    icon: {{'{'}}{{'}'}}
 *  {{'}'}}
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CfIconComponent.prototype.styling;
/**
 * <b>Output</b>
 * <p>Event emited on toggle</p>
 * @type {?}
 */
CfIconComponent.prototype.cfOnToggle;
/**
 * @hidden
 * @type {?}
 */
CfIconComponent.prototype.elementRef;
/**
 * @hidden
 * @type {?}
 */
CfIconComponent.prototype.templateService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
